import React, { useState } from 'react';

const AccordionPanels = ({ panels }) => {
  const [openPanels, setOpenPanels] = useState([]);

  const togglePanel = (panelIndex) => {
    setOpenPanels((prevOpenPanels) => {
      if (prevOpenPanels.includes(panelIndex)) {
        return prevOpenPanels.filter((i) => i !== panelIndex);
      } else {
        return [...prevOpenPanels, panelIndex];
      }
    });
  };

  return (
    <div id="accordion" className="panel-group" role="tablist">
      {panels.map((panel, index) => (
        <div key={index} className="panel panel-default panel-box">
          <div className="panel-heading" role="tab" id={`h${index}`}>
            <h4 className="panel-title">
              <button
                className="btn panel-title-btn"
                onClick={() => togglePanel(index)}
                aria-expanded={openPanels.includes(index) ? 'true' : 'false'}
              >
                {panel.title}
              </button>
            </h4>
          </div>
          {openPanels.includes(index) && (
            <div
              id={`c${index}`}
              className="panel-collapse"
              role="tabpanel"
              aria-labelledby={`h${index}`}
            >
              <div className="panel-body">
                <div dangerouslySetInnerHTML={{ __html: panel.content }} />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AccordionPanels;
